import React from "react"
import PropTypes from "prop-types"


class ChatTextArea extends React.Component {
  constructor(props) {
    super(props)

    this.updateText = this.updateText.bind(this)
    this.sendMessage = this.sendMessage.bind(this)
  }

  updateText(event) {
    this.props.updateText(event.target.value)
  }

  sendMessage() {
    if(this.props.textbox != '') {
      this.props.sendMessage(this.props.textbox)
    }
  }

  render() {
    return(
      <div className="chatboxinput">
        <div className="chat_message_wrapper">
          <textarea
            className="chatboxtextarea"
            style={{width: '100%', height: 100}}
            value={this.props.textbox}
            rows="1"
            cols="10"
            onChange={this.updateText}
            placeholder="Type a message..."
          />
          <button
            onClick={() => this.sendMessage()}
            className="sendChat" />
        </div>
      </div>
    )
  }

}

export default ChatTextArea;
